import {Container} from 'react-bootstrap';
import {Row} from 'react-bootstrap';
import {Col} from 'react-bootstrap';
import {Nav} from 'react-bootstrap';
import { FaFacebookF } from "react-icons/fa";
import { FaGithub } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";

function Intro(){
     const color = {color:"white"};
     const iconColor = {color:"tomato"};

   return(
   <div className="Intro">
        <Container style={color}>
  <Row>
    <Col xs={12} md={8} className="mt-5">
            <div className="intro">
                <h4 className="hi-head">Hi, I'm</h4>
                <h1 className="name">Vidhur Rajkumar</h1>
                <h5>Web Developer, Photographer</h5>
                <hr className="hor-line"/>
                <Row>
                <Nav as="ul">
  <Nav.Item as="li">
    <a href="#h" className="links" eventKey="link-1"><FaFacebookF style={iconColor}/></a>
  </Nav.Item>
  <Nav.Item as="li">
    <a href="https://github.com/Vidhur44" className="links" eventKey="link-2"><FaGithub style={iconColor}/></a>
  </Nav.Item>
  <Nav.Item as="li">
    <a href="#h" className="links" eventKey="link-3"><FaInstagram style={iconColor}/></a>
  </Nav.Item>
  <Nav.Item as="li">
    <a href="www.linkedin.com/in/vidhur-rajkumar-b9581515a" className="links" eventKey="link-4"><FaLinkedinIn style={iconColor}/></a>
  </Nav.Item>
</Nav>
                </Row>
            </div>
    </Col>
    <Col xs={6} md={4}>
    <img src="https://img.icons8.com/color/280/000000/launched-rocket--v2.png" alt="hi" className="hi"/>
    </Col>
  </Row>
</Container>
  </div>
);
}

export default Intro;